import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {CurrencyService} from 'app/blocks/service/api/currency.service';
import {Resource} from 'app/constants/resource';

import {ENTITIES_SETUP_BASE_URL} from 'app/app.constants';
import {ICurrency} from 'app/blocks/model/currency.model';
import {EntityNavigator} from 'app/blocks/routing/navigator';
import {Currency} from 'app/blocks/model/currency.model';
import {EntityUrlProvider} from 'app/blocks/routing/entity-url-provider';
import {AbstractEntityResource} from 'app/blocks/resource/abstract-entity-resource';
import {DefaultVat, IDefaultVat} from 'app/blocks/model/default-vat.model';
import {DefaultVatService} from 'app/blocks/service/api/default-vat.service';

@Injectable({
    providedIn: 'root'
})
export class DefaultVatResource extends AbstractEntityResource<IDefaultVat> {
    constructor(defaultVatService: DefaultVatService, router: Router) {
        super(
            Resource.DEFAULT_VAT,
            defaultVatService,
            new EntityNavigator(ENTITIES_SETUP_BASE_URL, Resource.DEFAULT_VAT, router),
            new EntityUrlProvider(ENTITIES_SETUP_BASE_URL, Resource.DEFAULT_VAT),
            (entity?) => new DefaultVat(entity),
            (entity) => entity.id
        );
    }
}
